import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/redux/rootState';
import PropertyManager from '../../utils/propertyManager';
import { ensureUserAccessLoaded } from '../../utils/appDataLoader';

const useGetMenu = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector((state: RootState) => state.user);
  const menu = useSelector((state: RootState) => state.menu);
  const permissions = useSelector((state: RootState) => state.permissions);

  useEffect(() => {
    void ensureUserAccessLoaded(dispatch, currentUser, menu, permissions);
  }, [currentUser, dispatch, menu, permissions]);

  try {
    if (menu && PropertyManager.isDefined(menu) && menu.length > 0) {
      return menu;
    }
  } catch (error) {
    console.error('useGetMenu failed:', error);
  }
  return [];
};

export default useGetMenu;
